<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ modalTitle() }}
  </ng-template>
  <ng-template #content>
    <p>{{ text() }}</p>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button (click)="closeModal()" color="secondary" data-testid="delete-modal-cancel-button">{{ "Common.Cancel" | i18nextEager }}</doka-button>
        <doka-button (click)="confirmDelete()" color="primary" data-testid="delete-modal-confirm-button">{{ "Common.Delete" | i18nextEager }}</doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
